// ----------------------------------------------------------------------

export default function Table(theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        body: {
          '&:first-of-type': {
            paddingLeft: theme.spacing(3),
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(3),
          },
        },
        head: {
          '&:first-of-type': {
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderTopLeftRadius: theme.shape.borderRadius,
            boxShadow: `inset 8px 0 0 ${theme.palette.background.paper}`,
            paddingLeft: theme.spacing(3),
          },
          '&:last-of-type': {
            borderBottomRightRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            boxShadow: `inset -8px 0 0 ${theme.palette.background.paper}`,
            paddingRight: theme.spacing(3),
          },
          backgroundColor: theme.palette.background.neutral,
          color: theme.palette.text.secondary,
        },
        root: {
          borderBottom: 'none',
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `solid 1px ${theme.palette.divider}`,
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          height: 20,
          marginTop: 2,
          width: 20,
        },
        toolbar: {
          height: 64,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
            backgroundColor: theme.palette.action.selected,
          },
        },
      },
    },
  };
}
